<template>
    <div class="auth-login-container">
        <p class="title">
            Welcome back{{ userValues.firstName ? `, ${userValues.firstName}!` : '!' }}
        </p>
        <div class="login-form-wrapper">
            <div v-if="!authedRegister" class="email-input">
                <label for="email-input"> Email * </label>
                <input
                    v-model="$v.formValues.email.$model"
                    v-autofocus
                    @keydown="$v.formValues.email.$touch"
                    class="email-input"
                    name="email-input"
                    type="email"
                />
                <p
                    v-if="$v.formValues.email.$dirty && !$v.formValues.email.required"
                    class="error-msg"
                >
                    Please enter your email address.
                </p>
                <p
                    v-else-if="$v.formValues.email.$dirty && !$v.formValues.email.email"
                    class="error-msg"
                >
                    Please enter a valid email address.
                </p>
                <p v-else-if="serverErrors.email" class="error-msg">
                    {{ serverErrors.email }}
                </p>
            </div>
            <div class="pw-input">
                <label for="pw-input"> Password * </label>
                <input
                    v-model="$v.formValues.password.$model"
                    :type="passwordVisible ? 'text' : 'password'"
                    @keydown="$v.formValues.password.$touch"
                    @keyup.enter="handleLogin($v)"
                    class="pw-input"
                    name="pw-input"
                />
                <i
                    class="fa"
                    :class="passwordVisible ? 'fa-eye' : 'fa-eye-slash'"
                    :style="
                        $v.formValues.password.$error || serverErrors.password
                            ? { top: '33%' }
                            : {}
                    "
                    aria-hidden="true"
                    @click="togglePasswordVisibility"
                >
                </i>
                <p
                    v-if="$v.formValues.password.$dirty && !$v.formValues.password.required"
                    class="error-msg"
                >
                    Please enter your password.
                </p>
                <p v-else-if="serverErrors.password" class="error-msg">
                    {{ serverErrors.password }}
                </p>
                <p @click="handleRedirectResetPw" class="forgot-password">
                    Forgot your password?
                </p>
            </div>
        </div>
        <button @click="handleLogin($v)" class="login-btn">Continue</button>
        <AuthSocial role="user" />
    </div>
</template>
<script>
    import { required, email } from 'vuelidate/lib/validators'
    import { useLoginStep } from '@/composables/auth/useLoginStep'
    import { useAuth } from '@/composables/auth/useAuth'
    import AuthSocial from '@/components/auth/parts/AuthSocial.vue'

    export default {
        name: 'AuthLogin',
        components: {
            AuthSocial
        },
        setup() {
            const { userValues, authedRegister } = useAuth()
            const {
                passwordVisible,
                formValues,
                serverErrors,

                handleLogin,
                handleRedirectResetPw,
                togglePasswordVisibility
            } = useLoginStep()

            return {
                passwordVisible,
                authedRegister,
                userValues,
                formValues,
                serverErrors,

                handleLogin,
                handleRedirectResetPw,
                togglePasswordVisibility
            }
        },
        validations: {
            formValues: {
                email: { required, email },
                password: { required }
            }
        }
    }
</script>
<style lang="scss" scoped>
    $mobileMax: 600px;

    @media screen and (max-width: $mobileMax) {
        .title {
            align-self: flex-start !important;
        }
    }
    .auth-login-container {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        gap: 40px;

        .title {
            color: #dedede;
            font-family: Instrument Sans;
            font-size: 38px;
            font-style: normal;
            font-weight: 500;
            line-height: 110%;
            letter-spacing: -0.76px;
        }
        .login-form-wrapper {
            align-self: stretch;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 16px;

            .error-msg {
                color: #ed3c0d;
                font-family: Instrument Sans;
                font-size: 10px;
                font-style: normal;
                font-weight: 600;
                line-height: 130%;
                letter-spacing: 0.14px;
            }

            label {
                color: #acacac;
                font-family: Instrument Sans;
                font-size: 12px;
                font-style: normal;
                font-weight: 650;
                line-height: 135%;
                letter-spacing: 0.12px;
            }
            input {
                padding: 12px 16px 16px 16px;
                border-radius: 12px;
                border: 1px solid #8b8b8b;
                background: #262626;
                overflow: hidden;
                color: #dedede;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-family: Instrument Sans;
                font-size: 16px;
                font-style: normal;
                font-weight: 550;
                line-height: 125%;
            }

            .email-input,
            .pw-input {
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                align-self: stretch;
                gap: 6px;
            }

            .pw-input {
                position: relative;

                .forgot-password {
                    cursor: pointer;
                    margin-top: 6px;
                    color: #8b8b8b;
                    font-family: Instrument Sans;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 130%;
                    letter-spacing: 0.14px;
                    text-decoration-line: underline;
                }
                .fa {
                    color: #acacac;
                    position: absolute;
                    left: 93%;
                    top: 39%;
                }
            }
        }
        .login-btn {
            padding: 11px 30px 12px 30px;
            border-radius: 100px;
            background: #cdeb09;
            align-self: stretch;
            color: #121212;
            font-family: Instrument Sans;
            font-size: 18px;
            font-style: normal;
            font-weight: 550;
            line-height: 120%;
        }
    }
</style>
